import * as v from 'valibot';

import { vcTwoLetterCountryCode } from '../../../utils/valibot/custom-types';
import { newSchema } from '../../../utils/valibot/schema';

export const TolerantPostResultSchema = newSchema(
  'TolerantPostResultSchema',
  v.object({
    street: v.string(),
    HouseNumber: v.string(),
    addressline2: v.string(),
    addressline3: v.string(),
    building: v.string(),
    subbuilding: v.string(),
    dependantstreet: v.string(),
    addresskey: v.string(),
    postalcode: v.string(),
    locality: v.string(),
    city: v.string(),
    subcity: v.string(),
    province: v.string(), // The full name of the province of the address
    provincecode: v.string(), // The abbreviation of the province of the address
    countrycode: vcTwoLetterCountryCode, // The 2-character ISO code of the country of the address
    country: v.string(), // The full name of the country of the address
    ReturnCode: v.pipe(v.string(), v.regex(/\d+/, 'ReturnCode expects an integer as string')), // The exit code of the query. Same as above
    // The overall quality of the address between 0 (worst) and 5 (best)
    // https://regex101.com/r/a85xxj/1
    score: v.pipe(v.string(), v.regex(/[0-5]([,.]\d+)?/, '')),
    quality: v.string(), // The similarity between the input and output addresses
    ShortReport: v.string(), // A summary of the quality of the address
    ElementInputStatus: v.string(), // The quality of the introduced data
    ElementResultStatus: v.string(), // The quality of the responded data
    post_singleline: v.string(),
    Language: v.string(),
    pobox: v.string(),
  }),
);

export const TolerantPostResponseModelSchema = newSchema(
  'TolerantPostResponseModelSchema',
  v.object({
    resultOverflow: v.boolean(), // 'true' if there are more results than those shown
    returnCode: v.number(), // Exit code of the query. Success is '0'
    errorMsg: v.string(), // Error message of the query. Success is 'OK'
    reqId: v.string(), // The same request id provided in the URL
    resultCount: v.number(),
    results: v.array(TolerantPostResultSchema),
  }),
);

export type TolerantPostResponseModel = v.InferOutput<typeof TolerantPostResponseModelSchema>;
export type TolerantPostResult = v.InferOutput<typeof TolerantPostResultSchema>;
